import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { Button, Form } from "react-bootstrap";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { orderActions } from "../../../_store";
import { ToastContainer } from "react-toastify";
import Toastr from "../../components/common/Toastr";
import JsBarcode from 'jsbarcode';
import jsPDF from "jspdf";


const SkidbarcodeGenerate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [selectedRows, setSelectedRows] = useState({});
    const barcodeRefs = useRef({});

    const orderForSkidBarcode = useSelector(
        (state) => state.order?.orderForSkidBarcode || []
    );

    useEffect(() => {
        showLoader();
        dispatch(orderActions.GetOrdersForSkidBarcode())
            .then(() => console.log("API call successful"))
            .catch((error) => console.error("API call failed:", error))
            .finally(() => hideLoader());
    }, [dispatch]);

    const handleCheckboxChange = (checkedSkidBreakdownID) => {
        if (!checkedSkidBreakdownID) return;
        setSelectedRows((prev) => ({
            ...prev,
            [checkedSkidBreakdownID]: !prev[checkedSkidBreakdownID],
        }));
    };
  




const handleGeneratePdf = () => {
  const selectedSkidNos = Object.keys(selectedRows).filter(
    (checkedSkidBreakdownID) => selectedRows[checkedSkidBreakdownID]
  );

  if (selectedSkidNos.length === 0) {
    Toastr("Please select at least one skid before printing.", "warning");
    return;
  }

  const doc = new jsPDF({
    unit: "pt",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  selectedSkidNos.forEach((checkedSkidBreakdownID, index) => {
    const skidData = orderForSkidBarcode.find(
      (order) =>
        order.OrderSkidBreakdownID.toString() === checkedSkidBreakdownID.toString()
    );

    const orderID = skidData.OrderNumber;
    const formattedSkidNo = skidData.SkidIndex;
    const clientName = skidData.CompanyName;
    const combinedValue = `${orderID}-${formattedSkidNo}`;

    // Create barcode on canvas
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, combinedValue, {
      format: "CODE128",
      displayValue: true,
      fontSize: 12,
      height: 50,
      margin: 10,
    });

    const imgData = canvas.toDataURL("image/png");
    const imgProps = doc.getImageProperties(imgData);
    const imgWidth = 220;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

    const textHeight = 10;
    const spacing = 2; // Adjusted vertical spacing between text and barcode
    const totalHeight = textHeight + spacing + imgHeight;

    const startY = (pageHeight - totalHeight) / 2;

    // Draw client name centered
    doc.setFontSize(14);
    doc.text(clientName, pageWidth / 2, startY + textHeight, { align: "center" });

    // Draw barcode image centered
    doc.addImage(
      imgData,
      "PNG",
      (pageWidth - imgWidth) / 2,
      startY + textHeight + spacing,
      imgWidth,
      imgHeight
    );

    // Add page if not the last one
    if (index < selectedSkidNos.length - 1) {
      doc.addPage();
    }
  });

  // Save and clear
  doc.save("SkidBarcodes.pdf");
  setSelectedRows({});
};





    //code 2  // working code
    const handleGenerate = () => {
        // Clear existing barcode canvases
        Object.keys(barcodeRefs.current).forEach((checkedSkidBreakdownID) => {
            if (barcodeRefs.current[checkedSkidBreakdownID]) {
                document.body.removeChild(barcodeRefs.current[checkedSkidBreakdownID]);
            }
        });
        barcodeRefs.current = {};
    
        const selectedSkidNos = Object.keys(selectedRows).filter(
            (checkedSkidBreakdownID) => selectedRows[checkedSkidBreakdownID]
        );
    
        if (selectedSkidNos.length === 0) {
            Toastr("Please select at least one skid before printing.", "warning");
            return;
        }
    
        const printWindow = window.open("", "_blank", "width=auto,height=auto");
    
        printWindow.document.write(`
            <html>
                <head>
                    <style>
                        @page {
                            margin: 0;
                            size: auto;
                        }
                        body {
                            margin: 0;
                            font-family: Arial, sans-serif;
                        }
                        .barcode-page {
                            height: 100vh;
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            box-sizing: border-box;
                            page-break-after: always;
                        }
                        .client-name {
                            font-size: 14px;
                           
                            text-align: center;
                           
                        }
                        canvas {
                            margin: 0 auto;
                        }
                    </style>
                </head>
                <body>
                </body>
            </html>
        `);
    
        printWindow.document.close();
    
        printWindow.onload = () => {
            const body = printWindow.document.body;
    
            selectedSkidNos.forEach((checkedSkidBreakdownID) => {
                const skidData = orderForSkidBarcode.find(
                    (order) =>
                        order.OrderSkidBreakdownID.toString() ===
                        checkedSkidBreakdownID.toString()
                );
    
                const orderID = skidData.OrderNumber;
                const formattedSkidNo = skidData.SkidIndex;
                const clientName = skidData.CompanyName;
                const combinedValue = `${orderID}-${formattedSkidNo}`;
    
                const pageContainer = printWindow.document.createElement("div");
                pageContainer.className = "barcode-page";
    
                const clientDiv = printWindow.document.createElement("div");
                clientDiv.className = "client-name";
                clientDiv.textContent = clientName;
    
                const barcodeCanvas = printWindow.document.createElement("canvas");
    
                pageContainer.appendChild(clientDiv);
                pageContainer.appendChild(barcodeCanvas);
                body.appendChild(pageContainer);
    
                JsBarcode(barcodeCanvas, combinedValue, {
                    format: "CODE128",
                    displayValue: true,
                });
            });
    
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    
        setSelectedRows({});
    };
    
    
    

    
    const columns = [
        { Header: "Order ID", accessor: "OrderNumber", Filter: ColumnFilter },
       
        {
            Header: "Skid Number",
            accessor: "SkidIndex",
            Filter: ColumnFilter,
            Cell: ({ value }) => value.toString().padStart(4),
        },
        { Header: "Client Name", accessor: "CompanyName", Filter: ColumnFilter },
        {
            Header: "Create Date",
            accessor: "CreatedDate",
            fieldType: "Date",
            Filter: ColumnFilter,
            Cell: ({ value }) => {
                if (!value) return "";
                const date = new Date(value);
                return date.toLocaleDateString("en-GB");
            },
        },
        {
            Header: ({ rows }) => {
                // Get only visible row IDs on current page
                const visibleRowIDs = rows.map((row) => row.original.OrderSkidBreakdownID);
        
                const allChecked = visibleRowIDs.every((id) => selectedRows[id]);
                const someChecked = visibleRowIDs.some((id) => selectedRows[id]) && !allChecked;
        
                const handleSelectAllChange = (e) => {
                    const checked = e.target.checked;
                    const updatedSelection = { ...selectedRows };
        
                    visibleRowIDs.forEach((id) => {
                        updatedSelection[id] = checked;
                    });
        
                    setSelectedRows(updatedSelection);
                };
        
                return (
                    <div className="text-center">
                        <Form.Check
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleSelectAllChange}
                            ref={(el) => {
                                if (el) el.indeterminate = someChecked;
                            }}
                        />
                    </div>
                );
            },
            accessor: "select",
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row }) => {
                const skidNo = row.original.OrderSkidBreakdownID;
                const isChecked = !!selectedRows[skidNo];
        
                return (
                    <div className="text-center">
                        <Form.Check
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => handleCheckboxChange(skidNo)}
                        />
                    </div>
                );
            },
        }
        
        
    ];

    return (
        <>
            <PageTitle activeMenu="Skid Barcode Generate" motherMenu="Order" />
             <ToastContainer />
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title">Skid Barcode Generate</h4>
                              <Button
                              className="ms-auto me-1 d-flex justify-content-start"
                              variant="danger btn-rounded"
                              onClick={handleGeneratePdf}
                            >
                              <span className="btn-icon-start text-danger">
                                <i className="fa fa-solid fa-file-pdf"></i>
                                {/* <i className="fa fa-regular fa-file-excel"></i> */}
                              </span>
                              Generate Pdf
                     </Button>
                    <Button
                        variant="primary"
                        className="btn-rounded d-flex justify-content-start"
                        onClick={handleGenerate}
                    >
                       <i className="fa fa-barcode me-2 pt-1"></i> Generate Barcode

                    </Button>
           
                    
                </div>
                
                    
                <div className="card-body">
                    {loader ? (
                        <p className="text-center">Loading...</p>
                    ) : orderForSkidBarcode.length > 0 ? (
                        <Table columns={columns} data={orderForSkidBarcode} />
                    ) : (
                        <p className="text-center">No orders available.</p>
                    )}
                </div>
            </div>
        </>
    );


};

export default SkidbarcodeGenerate;
